import { Component, OnInit } from '@angular/core';
import { BrochureService } from 'app/services/brochure.service';

/**
 * Landing target for the app root and any unmatched route. The marketing/content
 * pages now live on the external brochure site, so we bounce the browser there.
 * This also catches stray in-app `navigate(['/'])` calls (e.g. after logout).
 */
@Component({
  selector: 'app-brochure-redirect',
  template: '<p style="text-align:center;margin-top:2rem">Redirecting…</p>',
})
export class BrochureRedirectComponent implements OnInit {

  constructor(private brochure: BrochureService) {}

  ngOnInit(): void {
    this.brochure.goHome();
  }
}
